import { $$ } from '../../../shared/js/utils/dom';
import { initPlayer } from '../player/player';
import { initEmbed } from '../embed/embed';

export default class ToggleCookieOverlay {
  constructor(props) {
    this.container = props.container;
    this.subType = props.subType;
    this.iframesInitted = false;
  }

  init = () => {
    this.checkSubType(this.container);
  };

  checkSubType = container => {
    if (this.subType === 'videojs') {
      this.toggleClasses(container);
      initPlayer(this.container.querySelector('.player'));
    } else if (this.subType === 'embed') {
      this.toggleClasses(container);
      initEmbed(this.container.querySelector('.embed'));
    }
  };

  activateIframe = container => {
    this.toggleIframe(container);
    this.toggleClasses(container);
  };

  toggleClasses = container => container.classList.add('is-active');

  toggleIframe = container => {
    const iframes = $$('iframe, script', container);

    iframes.length &&
      iframes.forEach(iframe => {
        if (iframe.dataset.src && !iframe.hasAttribute('src')) {
          iframe.setAttribute('src', iframe.dataset.src);
        }
      });
  };
}
